import React from 'react';

import { Box, IconButton, Typography } from '@material-ui/core';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import { useAuth } from 'hooks';
import Image from 'next/image';

import blurBase64 from 'constants/blurBase64';

import GameIcon from 'components/@common/GameIcon/GameIcon';

interface TitleBarProps {
  title: string;
  iconUrl: string;
  category: string;
  isFavorited: boolean;
  bannerImage?: string;
  onFavoriteClick: (isFavorited: boolean) => void;
}

const TitleBar = ({
  title,
  iconUrl,
  category,
  isFavorited,
  bannerImage,
  onFavoriteClick,
}: TitleBarProps) => {
  const { isLoggedIn } = useAuth();
  return (
    <Box display="flex" flexDirection="column">
      {bannerImage && (
        <Box width="100%" height={148} position="relative" overflow="hidden">
          <Image
            src={bannerImage}
            alt={title}
            layout="fill"
            objectFit="cover"
            priority
            blurDataURL={blurBase64}
            placeholder="blur"
          />
        </Box>
      )}
      <Box p={4} display="flex" flexDirection="row" alignItems="center">
        <Box>
          <GameIcon src={iconUrl} size={64} alt={title} imagesAboveFold blurDataURL={blurBase64} />
        </Box>
        <Box ml={1} display="flex" flexDirection="column" justifyContent="center" flexGrow={1}>
          <Typography variant="h5" component="h1" color="textPrimary">
            {title}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {category}
          </Typography>
        </Box>
        <IconButton
          aria-label={isFavorited ? `unfavorite ${title}` : `favorite ${title}`}
          onClick={() => onFavoriteClick(!isFavorited)}
          disabled={!isLoggedIn}
        >
          {isFavorited ? <FavoriteIcon color="secondary" /> : <FavoriteBorderIcon />}
        </IconButton>
      </Box>
    </Box>
  );
};

export default TitleBar;
